import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "./lib/utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    thumbClassName?: string;
  }
>(({ className, thumbClassName, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex shrink-0 cursor-pointer items-center rounded-lg border p-0.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 h-4 w-8 border-[length:1px] data-[state=unchecked]:border-border data-[state=unchecked]:bg-muted dark:data-[state=unchecked]:border-[#39394B] dark:data-[state=unchecked]:bg-[#1E1E29] data-[state=checked]:border-green-500 data-[state=checked]:bg-green-100 dark:data-[state=checked]:border-[#22C55E] dark:data-[state=checked]:bg-[#1B3A2A]",
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-3 w-3 rounded-lg shadow-sm ring-0 transition-transform data-[state=unchecked]:translate-x-0 data-[state=unchecked]:bg-background dark:data-[state=unchecked]:bg-[#D5D5D8] data-[state=checked]:translate-x-[15px] data-[state=checked]:bg-green-500",
        thumbClassName
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
